/* WonderPages PDP — Galerie, Mini-Review, UGC-Slider, Personalisieren-CTA, Sticky-Bar */
(function () {
  'use strict';

  // ----- Hero-Galerie -----
  function initGallery(root) {
    var thumbs = root.querySelectorAll('[data-wp-thumb]');
    var slides = root.querySelectorAll('[data-wp-slide]');
    if (!thumbs.length || !slides.length) return;

    function show(index) {
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
    }
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { show(i); });
    });
    show(0);
  }

  // ----- Mini-Review-Slider (rotiert ALLE Blöcke, kein Limit) -----
  function initMiniReview(root) {
    var wrap = root.querySelector('.wp-pdp-minireview');
    var dots = root.querySelectorAll('[data-wp-mini-dot]');
    var quotes = root.querySelectorAll('[data-wp-mini-quote]');
    if (!quotes.length) return;

    var idx = 0;
    var timer = null;

    function show(i) {
      idx = i;
      dots.forEach(function (d, j) { d.classList.toggle('is-active', i === j); });
      quotes.forEach(function (q, j) { q.style.display = i === j ? '' : 'none'; });
    }

    function next() { show((idx + 1) % quotes.length); }

    function start() {
      if (timer || quotes.length < 2) return;
      timer = setInterval(next, 5500);
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    dots.forEach(function (d, i) {
      d.addEventListener('click', function () {
        show(i);
        stop(); start(); // Timer nach manueller Auswahl neu starten
      });
    });

    // Auf Touch/Hover pausieren, danach weiterlaufen
    if (wrap) {
      wrap.addEventListener('mouseenter', stop);
      wrap.addEventListener('mouseleave', start);
      wrap.addEventListener('touchstart', stop, { passive: true });
    }

    show(0);
    start();
  }

  // ----- Sterne im Hero → smooth-scroll zu den Reviews -----
  function initRatingScroll(root) {
    var trigger = root.querySelector('[data-wp-rating-scroll]');
    if (!trigger) return;
    trigger.addEventListener('click', function (e) {
      // judge.me-Widget bevorzugen, sonst eigenes Reviews-Grid (#reviews)
      var target = document.querySelector('#judgeme_product_reviews, .jdgm-widget, .jdgm-rev-widg')
                || document.getElementById('reviews')
                || document.querySelector('.wp-pdp-reviews');
      if (!target) return; // kein Ziel → Anker-Default greifen lassen
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  // ----- UGC-Slider -----
  function initUgc(root) {
    var track = root.querySelector('[data-wp-ugc-track]');
    var slides = root.querySelectorAll('[data-wp-ugc-slide]');
    var prev = root.querySelector('[data-wp-ugc-prev]');
    var next = root.querySelector('[data-wp-ugc-next]');
    var dotsWrap = root.querySelector('[data-wp-ugc-dots]');
    if (!track || !slides.length) return;

    var perView = window.matchMedia('(max-width: 800px)').matches ? 1 : 4;
    var pages = Math.max(1, Math.ceil(slides.length / perView));
    var page = 0;

    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      for (var i = 0; i < pages; i++) {
        var b = document.createElement('button');
        b.className = 'wp-pdp-ugc__dot';
        b.setAttribute('data-wp-ugc-dot', i);
        b.addEventListener('click', (function (idx) {
          return function () { goTo(idx); };
        })(i));
        dotsWrap.appendChild(b);
      }
    }

    function goTo(p) {
      page = Math.max(0, Math.min(pages - 1, p));
      var offset = -(page * 100);
      track.style.transform = 'translateX(' + offset + '%)';
      var dots = root.querySelectorAll('[data-wp-ugc-dot]');
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === page); });
    }

    if (prev) prev.addEventListener('click', function () { goTo(page - 1); });
    if (next) next.addEventListener('click', function () { goTo(page + 1); });
    goTo(0);
  }

  // ----- "Mein Buch personalisieren"-CTA → Funnel-Mode -----
  function initCta(root) {
    var ctas = root.querySelectorAll('[data-wp-personalize]');
    ctas.forEach(function (cta) {
      cta.addEventListener('click', function (e) {
        e.preventDefault();
        var url = new URL(window.location.href);
        url.searchParams.set('view', 'funnel');
        url.searchParams.set('step', '1');
        window.location.href = url.toString();
      });
    });
  }

  // ----- Sticky Mobile-CTA: sichtbar sobald der Hero-CTA weggescrollt ist -----
  function initStickyBar() {
    var bar = document.querySelector('[data-wp-stickybar]');
    var heroCta = document.querySelector('.wp-pdp-hero .wp-pdp-cta');
    if (!bar || !heroCta) return;

    function setVisible(v) {
      bar.classList.toggle('is-visible', v);
      bar.setAttribute('aria-hidden', v ? 'false' : 'true');
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          // Hero-CTA sichtbar → Bar aus; weggescrollt → Bar an
          setVisible(!entry.isIntersecting);
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0 });
      io.observe(heroCta);
    } else {
      // Fallback ohne IO: ab 600px Scroll einblenden
      window.addEventListener('scroll', function () {
        setVisible(window.scrollY > 600);
      }, { passive: true });
    }
  }

  // ----- Boot -----
  function boot() {
    var pages = document.querySelectorAll('.wp-pdp-page');
    pages.forEach(function (root) {
      initGallery(root);
      initMiniReview(root);
      initUgc(root);
      initCta(root);
      initRatingScroll(root);
    });
    initStickyBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();